module.exports = __webpack_public_path__ + "static/media/sentences.16736696.txt";